/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import '../behaviors/log-out-behaviour.js';
import '../behaviors/mpin-register-behaviour.js';

class setMpin extends mixinBehaviors([corpBehaviours.logOutBehaviour, corpBehaviours.mpinRegisterBehaviour], PolymerElement) {

  static get properties() {
    return {

      confirm_mpin: {
        type: String,
        notify: true,
        observer: '_checkPwEqual'
      },
      errorMessage: {
        type: String,
        notify: true
      },
      profilePage: {
        type: Boolean,
        value: false,
        notify: true
      },
      selectedPage: {
        type: Number,
        notify: true,
        observer: 'setMpinHeaderFocus'
      },
      showUserName: {
        type: String,
        notify: true
      },
      hideShowUserName: {
        type: Boolean,
        notify: true,
        value: true
      },
      selected: {
        type: Number,
        notify: true
      },
      phone: {
        type: String,
        notify: true,
        observer: 'changeStyle'
      },
      currentPassword: {
        type: String,
        value: "",
        notify: true
      },
      loginModeData: {
        type: Object,
        notify: true
      },
      successMsg: {
        type: String,
        notify: true
      },
      show: {
        type: Boolean,
        value: false,
        notify: true
      },
      username: {
        type: String,
        value: "",
        notify: true
      },
      enterPwd: {
        type: String,
        notify: true,
        value: getLabel('l_EnterPassword')
      },
      mpinAuthList: {
        type: Object,
        notify: true
      },
      showCorrectIcon: {
        type: Boolean,
        value: true,
        notify: true
      },
      newPwd: {
        type: String,
        notify: true,
        value: getLabel('l_NewPassword')
      },
      confirmPwd: {
        type: String,
        notify: true,
        value: getLabel('l_ReEnterPassword')
      }
    };


  }
  /**
   * Array of strings describing multi-property observer methods and their
   * dependant properties
   */
  static get observers() {
    return [
      'validateMpin(mpinInput,confirmMpin)'
    ];
  }

  static get template() {
    return html `
        <style include="app-styles">
        .banner-skew[phone] {
            top: 7.5vw;
        }
        .correct-icon {
          --iron-icon-width: 24px;
          --iron-icon-height: 24px;
        }
    </style>
    <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
    <oe-ajax id="logoutAjax" method="post" content-type="application/json" body="{{objData}}" on-response="_handleResponse" on-error="_handleError"></oe-ajax>
    <div class="mdl-grid mdl-grid--no-spacing" phone$="{{phone}}">

        <div class="mdl-cell--8-col mdl-cell--6-col-desktop position-relative">
          
            <div class="banner-skew banner-brand full-width mdl-cell--hide-tablet" phone$="{{phone}}"></div>
            <div class="root-container mdl-grid mdl-right-no-spacing-phone">

                <div class="mdl-grid mdl-cell mdl-cell--hide-tablet position-relative mdl-cell--1-offset-desktop mdl-grid--no-spacing">
                  
                <div class="mdl-grid  mdl-cell--12-col-desktop mdl-cell"></div>
                <div class="mdl-grid  mdl-cell--12-col-desktop mdl-cell"></div>
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
    
                    <div class="outlineOffset mdl-grid mdl-cell--12-col-desktop mdl-cell" id="SetMpinHeader" tabindex="0">
                    <oe-i18n-msg class="primary-light-text-xl mdl-cell--12-col-desktop" msgid="l_setMPIN"></oe-i18n-msg>
  </div>
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                </div>
             

                <!--for desktop view only-->
                <div class="main-container mdl-cell--1-offset-tablet mdl-cell--6-col-tablet mdl-cell--1-offset-desktop mdl-cell--9-col-desktop mdl-cell"
                    wide-layout$="{{wide}}" extra-wide-layout$="{{extra-wide}}">
                    <!--for desktop view only-->
                    <div class="list-card background-transparent" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" elevation="0">
                        <div class="content mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-desktop margin-l-zero">
                        
                        <div class="mdl-cell">
                       <paper-password-input id="set_mpin" required="required" label="l_SetPin" value={{mpinInput}} class="cursor-pointer secondary-dark-text-xxl light-input-style"
                             oncopy="return false" onpaste="return false" auto-validate error-message="m_enterMPIN"></paper-password-input>
                       </div>
                       <div class="mdl-cell">
                        <oe-input id="confirm_mpin" required="required" class="light-input-style" disablecopypaste label="l_confirmPin" auto-validate error-message="m_enterConfirmMPIN"
                                     maxlength="34" value="{{confirmMpin}}">
                                    <div slot="suffix" hidden="{{showCorrectIcon}}">
                                        <iron-icon id="correct-tick" class="correct-icon" name="confActSucessIcon" icon="icons:check"></iron-icon>
                                        </div>
                          </div> 
                        </div>
                    </div>

                    <!--for desktop view only-->
                    <div class="btn align-end full-width">
                        <div class="mdl-grid"></div>
                        <div class="mdl-grid"></div>
                        <div class="mdl-grid mdl-cell mdl-cell--12-col-desktop mdl-grid--no-spacing margin-zero">
                            <paper-button id="prepwdCancel" class="secondary-button" on-tap="clearFields" raised>
                                <oe-i18n-msg class="" msgid="b_Cancel"></oe-i18n-msg>
                            </paper-button>

                            <paper-button id="prepwdProceed" class="primary-button"  raised on-tap="submitMpinPassword">
                                <oe-i18n-msg msgid="b_Submit"></oe-i18n-msg>
                            </paper-button>
                        </div>

                        <div class="mdl-cell mdl-grid"></div>
                        <div class="mdl-grid"></div>
                        <div class="mdl-grid"></div>
                        <div class="mdl-grid"></div>
                        <div class="mdl-grid"></div>
                       
                    </div>

                </div>
            </div>
        </div>

    </div>`;
  }
  validateMpin(mpinInput, confirmMpin) {
    if (!_.isEmpty(mpinInput) && !_.isEmpty(confirmMpin)) {
      if (mpinInput == confirmMpin) this.showCorrectIcon = false;
      else this.showCorrectIcon = true;
    } else this.showCorrectIcon = true;
  }
  changeStyle() {
    this.updateStyles();
  }
  _toggleVisibility() {
    if (this.$.set_mpin !== undefined && this.$.set_mpin.getAttribute('type') !== undefined) {
      if (this.$.set_mpin.getAttribute('type') === 'password') this.$.set_mpin.setAttribute('type', 'text');
      else if (this.$.set_mpin.getAttribute('type') === 'text') this.$.set_mpin.setAttribute('type', 'password');
    }
  }
  clearFields() {
    this.$.set_mpin.visible = false;
    this.$.confirm_mpin.visible = false;
    this.mpinInput = "";

    if (this.$.set_mpin != undefined) {
      this.$.set_mpin.invalid = false;
      this.$.confirm_mpin.invalid = false;
    }

    this.confirmMpin = "";
    if (!this.profilePage) this.goToLoginPage();
    else {
      this.backToMyProfile();
    }
  }
  submitMpinPassword() {
    if (!this.mpinInput) {
      this.fire("oe-show-error", getLabel('m_enterMPIN'));
      return false;
    } else if (!this.confirmMpin) {
      this.fire("oe-show-error", getLabel('m_enterConfirmMPIN'));
      return false;
    } else if (this.mpinInput != this.confirmMpin) {
      this.fire("oe-show-error", getLabel('m_validateMPIN'));
      return false;
    } else {

      if (typeof MAuth != 'undefined') {
        var self = this;

        var args = [{
          "userMPIN": this.mpinInput, //user given response
          "userID": this.mpinAuthList.userId, //response from /user-devices api
          "clientID": this.activateResponse.deviceId, //response from /user-devices api
          "userOTP": sbEncrypt.decrypt(this.otp), //user given response
          "seed": this.activateResponse.encryptedLicense //response from /user-devices api
        }];

        self.fire('start-processing-loader');

        MAuth.active(args, 'active', function (res) {

          var bodyDet = {
            "userId": self.mpinAuthList.userId,
            "orgId": self.mpinAuthList.userId,
            "userType": self.mpinAuthList.userType,
            "deviceId": self.mpinAuthList.deviceId
          };

          var ajaxCall = document.createElement('oe-ajax');
          ajaxCall.contentType = "application/json";
          ajaxCall.handleAs = "json";
          ajaxCall.url = "/api/UserDeviceConfirm/UserDeviceConfirm/confirm";
          ajaxCall.method = "post";
          ajaxCall.body = bodyDet;
          ajaxCall.addEventListener('error', function (err) {
            self.fire('stop-processing-loader');
            showAjaxError(err);
          });
          ajaxCall.addEventListener('response', function () {
            self.fire('stop-processing-loader');
            self.fire('oe-show-success', {
              message: "MPIN Registered Successfully",
              forever: true,
              actionName: getLabel('b_OK'),
              callBack: function () {
                self.navigatePage();
              }
            });
          });
          oeAjaxEventListner(ajaxCall);
          ajaxCall.body = document.getElementById('keyManagement').setSymKey(ajaxCall.body);
          ajaxCall.generateRequest();

        }, function (err) {

          self.showError(err);
        });

      }
    }
  }
  navigatePage() {
    if (!this.profilePage) {
      this.goToLoginPage();
    } else {
      window.oe_navigate_to("/logout");
    }

  }
  setMpinHeaderFocus() {
    if (this.selectedPage == 5) {
      this.$.SetMpinHeader.focus();
      if (this.$$('#set_mpin') && this.$$('#set_mpin').$$('#input'))
        this.$$('#set_mpin').$$('#input').getElementsByTagName('paper-icon-button')[0].$.icon.style.color = 'white';
    }
  }
}
customElements.define('set-mpin', setMpin);